export class Obm {
  id = 0;
  obm = '';
}
